import FormText from 'components/form/FormText';
import IndicatorButton from 'components/indicator/IndicatorButton';

import { useSettingProfile } from './hooks/useSettingProfile';
import { getCompanyImageUrl, getDivLabel } from 'utils/app';

import type { JSX } from 'react';

/**
 * プロフィール設定画面
 */
export default function SettingProfile(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const {
    acctState,
    processing,
    useFormMethods: {
      register,
      formState: { errors },
    },
    onSave,
  } = useSettingProfile();

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-header">
        <div className="container">
          <div className="d-md-flex d-flex-header">
            <div className="flex-shrink-0 flex-left">
              <h2 className="flex-title">{acctState.user.name}さんのプロフィール</h2>
            </div>
            <div className="flex-grow-1 flex-right">
              <ul className="list-inline list-btn mb-0">
                <li className="list-inline-item">
                  <button
                    onClick={onSave}
                    className="btn btn-common btn-common-w147 moderate-blue"
                    disabled={processing}
                  >
                    <IndicatorButton visible={processing} />
                    保存する
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="section-profile">
        <div className="container">
          <div className="box-common">
            <form className="form-profile g-3">
              <div className="row form-row flex-md-row justify-content-between">
                <div className="column col-lg-6 col-xl-6 col-left">
                  <FormText
                    subject="氏名"
                    name="userName"
                    register={register}
                    errors={errors}
                    required={true}
                    maxLength={100}
                    requiredMark={true}
                  />
                </div>
                <div className="column col-lg-6 col-xl-6 col-left">
                  <div className="form-label">ログインメールアドレス</div>
                  <p className="ms-4 fw-bold mb-0">{acctState.user.mailAddress}</p>
                </div>
              </div>
              <div className="row form-row">
                <div className="column col-lg-6 col-xl-6 col-left">
                  <div className="form-label">ユーザー権限</div>
                  <p className="ms-4 fw-bold mb-0">
                    {getDivLabel('role', acctState.company.member?.roleDiv)}
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      <section className="section-companies">
        <div className="container">
          <div className="d-md-flex d-flex-header">
            <div className="flex-shrink-0 flex-left">
              <h2 className="flex-title">参加しているカンパニー</h2>
            </div>
          </div>
          <div>
            <ul className="list-unstyled list-company d-flex flex-wrap">
              {acctState.user.companies.map(item => {
                return (
                  <li key={`setting-profile-company-${item.id}`} className="me-2">
                    <a key={item.id} href={`/ws/${item.cd}`} className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img
                          src={getCompanyImageUrl(item.imageKey)}
                          className="icon icon-business img-fluid cropper-img"
                          alt={item.name}
                          width={80}
                        />
                      </div>
                      <p className="flex-grow-1 flex-text mb-0">{item.name}</p>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
